import {appApiQHs} from "@/apis/api.js";
import { AxiosError } from "axios";
export async function obtenirVersioGW(){   
    try {
        const url=`api/version`
        const version = await appApiQHs.get(
        url
        ).then(function(r){
            //console.log(r.data)
            return r.data})
        //console.log(version)
        return version
    } catch (error) {
        console.log(error)
        return error
    }
}
export async function obtenirVersioQH(){   
    try {
        const url=`api/versionqh`
        const version = await appApiQHs.get(
        url
        ).then(function(r){
            //console.log(r.data)
            return r.data})
        //console.log(version)
        return version
    } catch (error) {
        console.log(error)
        return error
    }
}
export async function obtenirEmpleatPerEmail(email){    
    try {
        const url=`api/obtenirempleatperemail`
        const params= {
            'email':`${email}`,
        }
        const empleat = await appApiQHs.get(
        url,{params}
        ).then(r=>r.data.data[0])
        //console.log(empleat)
        return empleat
    } catch (error) {
        console.log(error)
        return error
    }
}
export async function obtenirEmpleatQHs(idSage){    
    try {
        const url=`api/obtenirempleatqhs`
        const params= {
            'idSage':`${idSage}`,
        }
        const empleat = await appApiQHs.get(
        url,{params}
        ).then(r=> r.data.data[0])
        return empleat
    } catch (error) {
        return error
    }
}
export async function obtenirTagsEmpleat(idSage){    
    try {
        const url=`api/obtenirtagsempleat`
        const params= {
            'idSage':`${idSage}`,
        }
        const tags = await appApiQHs.get(
            url,{params}
            ).then(r=>r.data.data)
            //console.log(empleat)
            return tags
        } catch (error) {
            return error
        }
    }
    
export async function inserirTagEmpleat(idSage,tag){    
    try {
        const url=`api/inserirnoutag`
        const params= {
            'idSage':`${idSage}`,
            'tag':`${tag}`,
        }
        //console.log(params)
        const data = await appApiQHs.post(
            url,params
            ).then(r=>r.data.data[0])
            return data
        } catch (error) {
            throw new AxiosError(error)
        }
    }
export async function baixaTagEmpleat(idSage,tag){    
    try {
        const url=`api/baixatag`
        const params= {
            'idSage':`${idSage}`,
            'tag':`${tag}`,
        }
        const data = await appApiQHs.put(
            url,params
            ).then(r=>r.data.data[0])
            return data
            
        } catch (error) {
            throw new AxiosError(error)
        }
    }
            
            
export async function obtenirComputiMarcatgesperMes(idEmpleat,data){    
    try {
        const url=`api/obtenirComputiMarcatgesperMes`
        const params= {
            'idEmpleat':`${idEmpleat}`,
            'data':`${data}`,
        }
        const computs = await appApiQHs.get(
        url,{params}
        ).then(r=> r.data.data)
        //console.log(computs)
        return computs
    } catch (error) {
        console.log(error)
        return error
    }
}